import { useEffect, useState } from 'react';
import { getPriceLockEligibility } from '../../services/price-lock';

type UsePriceLockEligibilityParams = {
  priceLockFF?: boolean;
  enabled?: boolean;
};

type UsePriceLockEligibilityReturn = {
  isEligible: boolean;
  isLoading: boolean;
  error: Error | null;
};

export const usePriceLockEligibility = ({
  priceLockFF,
  enabled = true,
}: UsePriceLockEligibilityParams = {}): UsePriceLockEligibilityReturn => {
  const [isEligible, setIsEligible] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    if (!enabled) return;

    const checkEligibility = async (): Promise<void> => {
      if (!priceLockFF) {
        setIsEligible(false);
        setError(null);
        setIsLoading(false);
        return;
      }

      try {
        const { eligible } = await getPriceLockEligibility();
        setIsEligible(eligible);
      } catch (err) {
        setError(err instanceof Error ? err : new Error('Unknown error occurred'));
        setIsEligible(false);
      } finally {
        setIsLoading(false);
      }
    };

    checkEligibility();
  }, [priceLockFF]);

  return {
    isEligible,
    isLoading,
    error,
  };
};
